export const ButtonClassTypes = {
  WARNING: 'warning',
  MODIFY: 'modify',
  ARCHIVE: 'archive',
}
